
import { DefaultEditor } from 'ng2-smart-table';
import { Component, OnInit } from '@angular/core';
import { VentanaModalComponent } from './ventanamodal.component';
import { NbDialogService } from '@nebular/theme';

import { CustomCriteriaService } from './customCriteriaService';
import { MatDialog } from '@angular/material/dialog';

/**
 * Componente que renderiza la celda Criterios Validación en la tabla de customform
 */
@Component({
  template: `
  <ng-container *ngIf="cell.getColumn().isEditable">
  <div style="display: inline-flex;">
    <label>{{resultado}}</label>
    <button nbButton status="primary" (click)="abrirVentanaModal()">
    <nb-icon icon="edit-outline"></nb-icon>
    </button>
  </div>
  </ng-container>
  `,
})
export class CriteriosValidacionComponent extends DefaultEditor implements OnInit {
  currentValueCV: any;
  fieldEnabled = false;
  availableFields: any = {
    'CriteriosValid': ['date','date_range','datetime','datetime_range','hour','hours','number'],
  }
  vTipo = "";
  resultado = "";

  constructor(private dialogService: NbDialogService,
    private dialog: MatDialog,
    private modalService: CustomCriteriaService) {
    super();
  }

  ngOnInit(): void {
    /*
    for (let val in this.availableFields.CriteriosValid){
      if (this.availableFields.CriteriosValid[val] == this.cell.getRow().getData().type){
        this.fieldEnabled = true
        this.currentValueCV = this.cell.newValue
      }
    }



    if (this.fieldEnabled == false) {
      this.currentValueCV = ""
    }
*/

this.currentValueCV = this.cell.getRow().getData().criteria
this.vTipo = (this.cell.getRow().getData() as any).type;
    if (this.currentValueCV != undefined && this.currentValueCV != ""){
      /*
      if (this.modalService.vTip != "") {
        this.vTipo = this.modalService.vTip //Se va a cambiar el tipo
        this.resultado = ""
      }else{

      }
      */

      if(this.vTipo != undefined){
        this.resultado = this.modalService.validaExpresion(this.currentValueCV, this.vTipo)
        if(!this.resultado.startsWith("Valor ")){
          this.currentValueCV = "";
          this.resultado = '';
      }
      }


    }

    this.modalService.typeChangeEventEmitter.subscribe(newValue => {
      if(newValue != '' && newValue != this.vTipo){
        this.currentValueCV = "";
        this.resultado = "";
        this.vTipo = newValue;
      }
    })


    this.modalService.showModal().subscribe((value) => {
      if (value.currentValueCV != undefined){
        this.currentValueCV = value.currentValueCV
      }
    });
  }
  /**
   * Abre ventana modal para introducir los criterios de validación
   */

  abrirVentanaModal() {
      let dialogRef = this.dialog.open(VentanaModalComponent, {
        data: {vTipo:this.vTipo, currentValueCV:this.currentValueCV, resultado:this.resultado}
      });
      dialogRef.afterClosed().subscribe(result => {
        //this.modalService.closeModal(result);
        if(result != undefined){
          this.resultado = result.resultado;
          this.currentValueCV = result.currentValueCV;
          this.cell.newValue = this.currentValueCV.replaceAll("\\|","==TUBERIA==").split("\\|").map(e => { return e.replaceAll("==TUBERIA==","|")});
        }

      });
  }

  public change(event) {

    this.cell.newValue = this.currentValueCV.replaceAll("\\|","==TUBERIA==").split("\\|").map(e => { return e.replaceAll("==TUBERIA==","|")});

  }


}
